var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _circle4, _circle5, _path8, _polygon, _path9, _circle6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle7, _path25, _circle8, _path26, _circle9, _circle10, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawForms78Yw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b71cf957-6104-44bf-a28a-c3091bf56141",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 820.75903,
    height: 568.3632,
    viewBox: "0 0 820.75903 568.3632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850.57591,504.82881l-9.66971,13.186a9.3336,9.3336,0,0,1-11.76852,2.79447h0a9.33361,9.33361,0,0,1-.905-16.10031l12.33107-8.151L875.824,461.29756l3.91782-12.62406h26.55406l-13.93,30.03656Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M559.92029,504.0647a4.636,4.636,0,0,0-4.63051,4.63052V728.18176a4.636,4.636,0,0,0,4.63051,4.63052H856.27343a4.636,4.636,0,0,0,4.63052-4.63052V508.69522a4.636,4.636,0,0,0-4.63052-4.63052Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M568.16156,720.28566H848.03217V516.59132H568.16156Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M808.5791,574.91163H640.02825a6.01967,6.01967,0,1,0,0,12.03934H808.5791a6.01967,6.01967,0,0,0,0-12.03934Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M640.02825,611.95577a6.01967,6.01967,0,1,0,0,12.03934H808.5791a6.01967,6.01967,0,0,0,0-12.03934Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M640.02825,648.99991a6.01968,6.01968,0,0,0,0,12.03935H808.5791a6.01968,6.01968,0,0,0,0-12.03935Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 418.45719,
    cy: 415.57595,
    r: 7.40883,
    fill: "#00b0ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.45719,
    cy: 452.62009,
    r: 7.40883,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.45719,
    cy: 489.66423,
    r: 7.40883,
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M741.43659,580.93129h0a6.01967,6.01967,0,0,1-6.01967,6.01967H640.24514a6.16706,6.16706,0,0,1-6.1844-5.21971,6.03053,6.03053,0,0,1,5.96751-6.81964h95.38867A6.01966,6.01966,0,0,1,741.43659,580.93129Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.47638,
    cy: 288.2367,
    r: 24.07869,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.47638,
    cy: 288.2367,
    r: 12.03935,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M976.81653,696.3663l-12.18875,5.65906L946.10627,666.8311c-11.43465-17.5167-18.8982-38.50844-24.13911-61.44511l19.15374,1.30594c11.40283,16.27531,19.85274,32.59328,22.57568,48.99407Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "755.418 445.227 731.041 445.227 731.041 403.001 750.63 399.519 755.418 445.227",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M913.71168,451.75943a120.11147,120.11147,0,0,0-36.0424-1.35786l7.04551-35.13738a16.44328,16.44328,0,0,1,13.99678-13.07257h0a16.44328,16.44328,0,0,1,18.46977,18.10791Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.88089,
    cy: 193.39839,
    r: 20.45969,
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M928.06153,382.94132l-26.98937,19.15375-7.18266-34.172,20.242-8.05328C914.95167,368.82863,919.79075,376.45422,928.06153,382.94132Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M916.96106,357.04023c-1.51333-3.11862-3.4078-.95452-5.09064,2.84938l-2.41407-9.6563-2.89689-.96563-1.93126-7.725c-8.85818-2.1154-15.96653,2.31011-25.104,7.22665l-3.4825,8.27094h0a20.99359,20.99359,0,0,1,14.1442-29.69143,22.04535,22.04535,0,0,1,4.618-.5353h0a21.92851,21.92851,0,0,1,22.14623,22.61226Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M980.35075,713.05925,938.70249,726.6437a6.33355,6.33355,0,0,1-7.09-3.57275h0a6.336,6.336,0,0,1,2.195-7.84913c8.214-5.62314,14.76-11.62212,17.76093-18.4202,2.77512-11.27216,5.91169-11.29777,9.31937-2.88766,9.41076,5.56676,7.89057,1.10821,13.7522-5.81859l9.03629,17.10442A5.50767,5.50767,0,0,1,980.35075,713.05925Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M881.91841,722.92036l-13.93-6.09437,4.99324-35.687,9.80738-70.09392,26.55406,3.4825a162.12855,162.12855,0,0,1-17.69163,69.92408Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M927.19091,621.92787l-46.14313-9.14156,12.18875-63.99094L891.06,531.38287H951.5684C949.36118,553.92586,938.83249,587.20872,927.19091,621.92787Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M953.745,537.47725c-22.33506-5.65333-44.30575-6.45333-65.73219,0-4.008-41.30066-5.11065-80.68359-1.60372-117.02384a33.77444,33.77444,0,0,1,11.84359-22.62169l25.45576-21.42009,18.90169,9.45085a14.97413,14.97413,0,0,1,8.2743,13.08421C955.01094,453.88944,958.17514,506.1733,953.745,537.47725Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M975.9459,530.51225l3.80541,13.31891a10.1802,10.1802,0,0,1-8.20077,12.85233h0A10.18018,10.18018,0,0,1,959.869,545.30411l1.71155-13.05061L952.439,466.086l-12.18875-26.11875,24.3775-10.88281L974.64,461.73288Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M877.47779,733.99325l-42.66-9.96177A6.33356,6.33356,0,0,1,830.605,717.302h0a6.336,6.336,0,0,1,5.94443-5.5759c9.939-.55326,18.64614-2.2922,24.73523-6.55156,8.21427-8.203,10.9102-6.59964,9.467,2.35912,5.16443,9.63742,6.17446,5.03639,14.777,2.14925l-1.13417,19.31137A5.50768,5.50768,0,0,1,877.47779,733.99325Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M968.54559,432.13163c-10.30732.84945-21.55169,6.82081-33.08375,14.36531l-8.84578-34.72789a16.44328,16.44328,0,0,1,6.9654-17.84055l0,0a16.44329,16.44329,0,0,1,24.485,8.3376Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.20943,240.61825a4.59435,4.59435,0,0,0-4.589,4.589V462.72333a4.59435,4.59435,0,0,0,4.589,4.589H487.9021a4.59435,4.59435,0,0,0,4.58895-4.589V245.2072a4.59435,4.59435,0,0,0-4.58895-4.589Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.12026,455.8125h279.8706V252.11816H201.12026Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.62654,348.24342a5.96563,5.96563,0,0,0,0,11.93127H453.485a5.96563,5.96563,0,1,0,0-11.93127Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.62654,384.955a5.96563,5.96563,0,1,0,0,11.93126H453.485a5.96563,5.96563,0,1,0,0-11.93126Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M329.1245,423.50217a5.96563,5.96563,0,0,0,0,11.93126H352.987a5.96563,5.96563,0,0,0,0-11.93126Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M309.08012,272.49307a1.83739,1.83739,0,0,0-1.83558,1.83558v46.59619a1.83739,1.83739,0,0,0,1.83558,1.83558h63.95129a1.83739,1.83739,0,0,0,1.83558-1.83558V274.32865a1.83739,1.83739,0,0,0-1.83558-1.83558Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#00b0ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.43528,
    cy: 126.65496,
    r: 10.09569,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M357.576,318.17147a10.01752,10.01752,0,0,1-1.10136,4.589H325.63691a10.09442,10.09442,0,0,1,8.99433-14.68463h12.84905A10.09,10.09,0,0,1,357.576,318.17147Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.43528,
    cy: 126.65496,
    r: 10.09569,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M357.576,318.17147a10.01752,10.01752,0,0,1-1.10136,4.589H325.63691a10.09442,10.09442,0,0,1,8.99433-14.68463h12.84905A10.09,10.09,0,0,1,357.576,318.17147Z",
    transform: "translate(-189.62048 -165.8184)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.43528,
    cy: 23.86253,
    r: 23.86253,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.43528,
    cy: 23.86253,
    r: 11.93126,
    fill: "#00b0ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "820.364 567.695 246.283 567.695 246.283 565.514 820.759 565.514 820.364 567.695",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawForms78Yw);
export default __webpack_public_path__ + "static/media/undraw_forms_78yw.35010e41c29b3371208cc76b36df208b.svg";
export { ForwardRef as ReactComponent };